import { GET_DEVICE_DATA, GET_DEVICE_CUSTOMER_ID } from '../actions/constants'

const initialState = {
  deviceData: {},
  customerID: '',
}

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_DEVICE_DATA:
      return {
        ...state,
        deviceData: action.payload,
      }
    case GET_DEVICE_CUSTOMER_ID:
      return {
        ...state,
        customerID: action.payload,
      }

    default:
      return {
        ...state,
      }
  }
}
